import React, { useEffect, useState } from "react";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import {
  Chip,
  FormControlLabel,
  Paper,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";

const ReminderSchedule = ({
  values,
  isPauseActive,
  handleChange,
  isEdit = false,
  isPatientEnroll = false,
}) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#F5F5F5",
      color: theme.palette.common.black,
      textAlign: "left",
      height: "60px",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      textAlign: "left",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      height: "60px",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

  const columns = [
    {
      header: "Reminder Stage",
      accessorKey: "name",
      width: "200px",
    },

    {
      header: "Active Channels",
      accessorKey: "activeChannels",
      width: "250px",
    },

    {
      header: "Status",
      accessorKey: "status",
    },
  ];

  const [rows, setRows] = useState([
    {
      name: "Next Send",
      value: "next_send",
      activeChannels: [],
      status: true,
      availableChannels: ["Email", "Call", "SMS"],
    },
    {
      name: "First Reminder",
      value: "first_call",
      activeChannels: [],
      status: true,
      availableChannels: ["Email", "Call", "SMS"],
    },
    {
      name: "Second Reminder",
      value: "second_call",
      activeChannels: [],
      status: true,
      availableChannels: ["Email", "Call", "SMS"],
    },
    {
      name: "Third Reminder",
      value: "third_call",
      activeChannels: [],
      status: true,
      availableChannels: ["Email", "Call", "SMS"],
    },
    {
      name: "Fourth Reminder",
      value: "letter",
      activeChannels: [],
      status: true,
      availableChannels: ["Letter"],
    },
  ]);

  useEffect(() => {
    if (values) {
      const updated = rows.map((row) => ({
        ...row,
        activeChannels: row.availableChannels.filter(
          (channel) => values?.notification_channels?.[channel.toLowerCase()]
        ),
        status: values?.[row.value] ?? row.status,
      }));
      setRows(updated);
    }
  }, [values]);

  return (
    <>
      <div
        className="d-flex justify-between align-items-center"
        style={{ marginTop: "32px", marginBottom: "8px", width: "100%" }}
      >
        <span
          style={{
            fontWeight: 500,
            fontSize: "16px",
            color: !isPatientEnroll ? "#175EC8" : undefined,
          }}
          className="d-flex align-items-center mb-3 "
        >
          {!isPatientEnroll && <ScheduleOutlinedIcon fontSize="small" />}
          <span className="ml-2">Reminder Schedule</span>
        </span>
        {isEdit ? (
          <FormControlLabel
            control={
              <Switch
                name="active"
                color="secondary"
                checked={values?.subscribe || false}
                disabled={isPauseActive}
              />
            }
            label="Reminders Enabled"
            labelPlacement="end"
            onChange={(e, c) => handleChange("subscribe", c)}
          />
        ) : (
          <Chip
            label={
              values?.subscribe ? "Reminders Enabled" : "Reminders Disabled"
            }
            icon={
              values?.subscribe ? (
                <NotificationsOutlinedIcon style={{ color: "#fff" }} />
              ) : (
                <NotificationsOffOutlinedIcon style={{ color: "#fff" }} />
              )
            }
            style={{
              backgroundColor: values?.subscribe ? "#4CAF50" : "#E0E0E0",
              color: "#fff",
            }}
          />
        )}
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700, tableLayout: "fixed" }}>
          {!isPatientEnroll && (
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <StyledTableCell
                    key={column.accessorKey}
                    style={{ width: column.width }}
                  >
                    {column.header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row.name}>
                <StyledTableCell style={{ width: columns[0].width }}>
                  <b>{row.name}</b>
                </StyledTableCell>
                <StyledTableCell style={{ width: columns[0].width }}>
                  {row.activeChannels.map((channel) => (
                    <Chip
                      label={channel}
                      key={channel}
                      className="mr-1"
                      style={{ backgroundColor: "#94BA33", color: "#fff" }}
                    />
                  ))}
                </StyledTableCell>
                <StyledTableCell style={{ width: columns[0].width }}>
                  {isEdit ? (
                    <FormControlLabel
                      control={
                        <Switch
                          name="active"
                          color="secondary"
                          defaultChecked={values[row.value] || false}
                          disabled={!values?.subscribe}
                          onChange={(_, c) => {
                            handleChange(row.value, c);
                          }}
                        />
                      }
                    />
                  ) : row.status ? (
                    "Active"
                  ) : (
                    "Inactive"
                  )}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReminderSchedule;
